import React from 'react';
import { useParams, Outlet, useNavigate } from 'react-router-dom';
import { Typography, Button, Paper, Tooltip, IconButton, Box } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import Progress from './Progress';
import { toQuestionsView, toQuizOverview } from '../../utils/routes';
import { useTranslation } from 'react-i18next';

export default function Questions(props) {

    let { subtopicId, activeQuestion } = useParams();
    const {i18n, t} = useTranslation()
    let navigate = useNavigate();

    const questions = props.questions.filter(quest => quest.subtopicId === subtopicId);
    const subtopic = props.subtopics.find(subtopic => subtopic.id === subtopicId);
    const translatedSubtopicName = subtopic ? subtopic.name[i18n.language] : ""

    if (!(questions && subtopic)) return null;

    const goToFirstQuestion = () => {
        navigate(toQuestionsView(subtopic.quizpartId, subtopicId));
    }

    const backToSubtopicOverview = () => {
        navigate(toQuizOverview);
    }
 
    return(
        questions && subtopic &&
        <Box sx={{display: "flex", flexDirection:"column", alignItems: "center"}}>
            <Paper sx={{p: 4, m: {xs: 1, sm: 2, lg: 3}, minWidth: "14rem"}}>
                <Paper sx={{display: "flex", justifyContent: "space-between", minWidth: "12rem", mb: 4, p: 2, bgcolor: "primary.main"}}>
                    <Typography color="white" align="center" variant="h2">{translatedSubtopicName}</Typography> 
                    <Tooltip enterTouchDelay={0} title="Zurück" onClick={backToSubtopicOverview}>
                        <IconButton color="secondary">
                            <ArrowBack/>
                        </IconButton>
                    </Tooltip>
                </Paper>
                <Progress activeQuestion={activeQuestion} size={questions.length}/>
                {
                    !activeQuestion ?
                    <Button onClick={goToFirstQuestion}>{t("quizStart")}</Button>
                    :<Outlet context={[questions]}/>
                }
            </Paper>
        </Box>
    )
}